module.exports = __webpack_public_path__ + "img/HFCT-50.def2ae47.webp";